export const SET_LOADING = `bases/set_loading`;
export const SET_BASES = `bases/set_bases`;
export const UPDATE_BASE = `bases/update_base`;



// WEBPACK FOOTER //
// ./src/store/base/bases/types.js